import { CollectdataService } from './../services/collectdata.service';
import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  data: any[];
  // Dateddata: any[];
  constructor(public collectDataService: CollectdataService) { }

  ngOnInit(): void {
  this.collectDataService.getData().subscribe(
    (data) => {
      // console.log(typeof(data));
      console.log(data);
      this.data = data.splice(1);
    }
  );
  this.modify();
  }
  modify(){
  // this.Dateddata = JSON.parse(this.data);
  // console.log(this.Dateddata);

  }
}
